export default class Profile {
  constructor(id, name, surname, email, roles) {
    this.id = id;
    this.name = name;
    this.surname = surname;
    this.email = email;
    this.roles = roles;
  }
}
